import React from 'react';
import { Menu as MuiMenu, styled } from '@mui/material';

const StyledMenu = styled(MuiMenu)(({ theme }) => ({
    '& .MuiPaper-root': {
        overflow: 'visible',
        marginTop: theme.spacing(1.5),
        '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            backgroundColor: theme.palette.background.paper,
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
        },
    },
}));

export const Menu = ({ anchorEl, open, onClose, anchorOrigin, transformOrigin, children }) => {
    
    const handleItemClick = (child) => {
        return React.cloneElement(child, {
            onClick: (event) => {
                if (child.props.onClick) {
                    child.props.onClick(event); // Call the original onClick handler
                }
                onClose(); // Close the menu
            },
        });
    };

    return (
        <StyledMenu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={anchorOrigin || { vertical: 'top', horizontal: 'right' }}
            transformOrigin={transformOrigin || { vertical: 'top', horizontal: 'right' }}
        >
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((child) => handleItemClick(child))}
        </StyledMenu>
    );
};